import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import * as fromProcess from '../../store/process/process.reducer';
import { ProcessType } from '../../model/process-type.model';
import { ProcessService } from '../../services/process.service';
import { TrackingService } from '../../tracking/tracking.service';
import { GtmService } from '../../services/gtm.service';

@Component({
  selector: 'app-step2',
  templateUrl: './step2.component.html',
})
export class Step2Component implements OnInit, OnDestroy {
  processKind$ = this.store.select(fromProcess.selectProcessKind);
  processKinds = ProcessType;
  countries: { [k: string]: { value: string; label: string }[] } | undefined;
  destroy$: Subject<void> = new Subject<void>();

  constructor(
    private store: Store<AppState>,
    private processService: ProcessService,
    private trackingService: TrackingService,
    private gtmService: GtmService,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(fromProcess.actions.setStep({ step: 1 }));
    this.gtmService.step2Event();
    this.processService.onPageInit();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
